import { AxiosInstance } from "axios";

export type SiteSettings = {
	storeEnabled: boolean;
	cartEnabled: boolean;
	subscriptionCouponCodesEnabled: boolean;
	merchCouponCodesEnabled: boolean;
};

const SITE_SETTINGS_API_PREFIX = "/site-settings";

export async function getSiteSettings(http: AxiosInstance): Promise<SiteSettings> {
	const body = await http.get<any>(SITE_SETTINGS_API_PREFIX);
	return (body.data || {}) as SiteSettings;
}

